var FileInfo = /** @class */ (function () {
    function FileInfo(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    FileInfo.prototype.init = function (data) {
        if (data) {
            this.id = data["id"];
            this.fileId = data["fileId"];
            this.contentLength = data["contentLength"];
            this.contentType = data["contentType"];
            this.fileName = data["fileName"];
            this.uploadTime = data["uploadTime"] ? new Date(data["uploadTime"].toString()) : undefined;
            this.clientMd5 = data["clientMd5"];
        }
    };
    FileInfo.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new FileInfo();
        result.init(data);
        return result;
    };
    FileInfo.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fileId"] = this.fileId;
        data["contentLength"] = this.contentLength;
        data["contentType"] = this.contentType;
        data["fileName"] = this.fileName;
        data["uploadTime"] = this.uploadTime ? this.uploadTime.toISOString() : undefined;
        data["clientMd5"] = this.clientMd5;
        return data;
    };
    FileInfo.prototype.clone = function () {
        var json = this.toJSON();
        var result = new FileInfo();
        result.init(json);
        return result;
    };
    return FileInfo;
}());
export { FileInfo };
